// extracted by mini-css-extract-plugin
module.exports = {"header":"dece2e673c--header--lb8ak","header_title":"dece2e673c--header_title--aXR7D"};